import $ from 'jquery';

const selector_trigger = '.accordion__heading';
const selector_target = '.accordion__content';

let accordionNumber = 0;
function resolveAccordionId(accordionContent: Element) {
	let id: string;
	if (!(id = accordionContent.parentElement.id).length) {
		id = accordionContent.parentElement.querySelector<HTMLElement>(selector_trigger)?.innerText
			.replace(/([a-z])([A-Z])/g, "$1-$2")
			.replace(/[\s_]+/g, '-')
			.toLowerCase();
		if (!id) {
			id = `p-accordion-${++accordionNumber}`;
		} else if (document.getElementById(id)) { // If the generated id would overlap with the id of another element on the page, we append a suffix to ensure that it remains unique
			id += "-" + (++accordionNumber);
		}
		accordionContent.parentElement.id = id;
	}
	if (!accordionContent.id) {
		accordionContent.id = id + "-content";
	}
	return id;
}

function toggleItem(element: Element, open: boolean): void {
	if (open) { // toggle returns true if we are opening the item
		$(element).stop(true).slideDown({duration: 400});

		// Se the fragment to the id of the accordion we are opening
		const url = new URL(window.location.href);
		url.hash = element.parentElement.id;
		history.replaceState(history.state, "", url);
	} else {
		$(element).stop(true).slideUp({duration: 400});

		// If the current fragment is the id of the accordion we are closing, remove it from the URL
		if (window.location.hash && window.location.hash.substring(1) === element.parentElement.id) {
			const url = new URL(window.location.href);
			const openAccordion = document.querySelector(".accordion.open");
			url.hash = openAccordion?.id ?? "";
			history.replaceState(history.state, "", url);
		}
	}
}

function setupIconAndButton(accordion: Element, accordionContentId: string) {
	const accordionTrigger = accordion.querySelector(selector_trigger);
	if (!(accordionTrigger.firstElementChild instanceof HTMLButtonElement)) {
		const button = document.createElement("button");
		button.innerHTML = `
			<svg width="10" height="10" viewBox="0 0 10 10" role="img" aria-hidden="true">
				<path class="path-V" d="M5,0C4.4,0,4,0.5,4,1V9c0,0.6,0.5,1,1,1c0.6,0,1-0.5,1-1V1C6,0.5,5.6,0,5,0z" />
				<path class="path-H" d="M9,4H1C0.5,4,0,4.4,0,5c0,0.6,0.5,1,1,1H9c0.6,0,1-0.5,1-1S9.5,4,9,4z" />
			</svg>
		`;

		button.setAttribute("aria-expanded", "false");
		button.setAttribute("aria-controls", accordionContentId);
		for (let node: typeof accordionTrigger.firstChild; (node = accordionTrigger.firstChild) !== null;) {
			button.appendChild(node);
		}
		accordionTrigger.appendChild(button);
	}
}

function wireUpAccordionGroup(accordionGroup: Element) {
	if (accordionGroup.classList.contains("js-ready")) {
		return;
	}

	accordionGroup.addEventListener('click', event => {
		if (event.target instanceof Element && event.target.closest("button")) {
			const heading = event.target.closest(selector_trigger);
			if (heading) {
				event.preventDefault();
				event.stopPropagation();

				const open = heading.parentElement.classList.toggle('open');
				const button = heading.querySelector("button");
				button.setAttribute("aria-expanded", open.toString());
				toggleItem(document.getElementById(button.getAttribute("aria-controls")), open);
			}
		}
	});

	const frag = window.location.hash ? window.location.hash.substring(1) : null;
	for (const accordion of accordionGroup.querySelectorAll(".accordion")) {
		const accordionContent = accordion.querySelector<HTMLElement>(selector_target);
		const accordionId = resolveAccordionId(accordionContent); // This also sets an id on the accordionContent element if one was not already set
		setupIconAndButton(accordion, accordionContent.id);

		if (accordionId === frag) {
			accordion.classList.toggle("open", true);
			accordion.querySelector("button").setAttribute("aria-expanded", "true");
		} else {
			accordionContent.style.display = "none"; // This is the equivalent of using JQuery's slideUp function with a duration of 0
		}
	}
	accordionGroup.classList.add("js-ready");
}

document.addEventListener('DOMContentLoaded', () => {
	// NOTE: accordion can only be a child of accordionGroup
	document.querySelectorAll('.accordionGroup').forEach(wireUpAccordionGroup);
	new MutationObserver(mutations => {
		for (const mutation of mutations) {
			for (const addedNode of mutation.addedNodes) {
				if (addedNode instanceof Element) {
					if (addedNode.classList.contains("accordionGroup")) {
						wireUpAccordionGroup(addedNode);
					}
					addedNode.querySelectorAll('.accordionGroup').forEach(wireUpAccordionGroup);
				}
			}
		}
	}).observe(document, {subtree: true, childList: true});
});
